import { validatePatternConfiguration } from '@df/ui/form/validate-pattern.config';

validatePatternConfiguration['telephone'] = {
    pattern: /^[0-9 +\-()]*$/
};

validatePatternConfiguration['nickname'] = {
    pattern: /^[A-Za-z0-9 _.,\-]+$/,
    errorMessage: "Your nickname can only contain letters, numbers and _.-, characters, emojis aren't supported"
};
